<template>
  <div>
    <pdl-callout v-if="!hasReplacement" kind="warning">
      <template #content>
        <span v-html="bp('archiveNoReplacement')" />
      </template>
    </pdl-callout>
    <div v-else>
      <pdl-callout kind="success">
        <template #content>
          <span v-html="bp('archiveReplacement')" />
        </template>
      </pdl-callout>
      <trek-button primary block @click="navigateToReplacement">
        <span v-html="bp('archiveViewCurrent')" />
      </trek-button>
    </div>
  </div>
</template>
<script>
import get from 'lodash/get';
import {Url} from '@/utils/url';
import {PdlCallout} from '@pedal/pdl-callout';
import TrekButton from '@/components/TrekButton';

export default {
  name: 'PdpReplacement',
  components: {TrekButton, PdlCallout},
  props: {
    replacementProduct: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    sku() {
      return get(this.replacementProduct, 'sku');
    },
    url() {
      const url = get(this.replacementProduct, 'url');
      return !url ? '' : Url.withContextPath(url);
    },
    hasReplacement() {
      return this.sku && this.url;
    },
  },
  methods: {
    navigateToReplacement() {
      window.location.href = this.url;
    },
  },
};
</script>
